// extracted by mini-css-extract-plugin
module.exports = {"empty-wishlist-container":"EmptyWishlist_empty-wishlist-container__lqWF5","emptyMessage":"EmptyWishlist_emptyMessage__3nRUt"};